export const Reaction = {
  DISLIKE: 1,
  LIKE: 2,
  UNDISLIKE: 3,
  UNLIKE: 4,
};
